import { render, staticRenderFns } from "./edit-group.vue?vue&type=template&id=40236e2e&scoped=true"
import script from "./edit-group.vue?vue&type=script&lang=js"
export * from "./edit-group.vue?vue&type=script&lang=js"
import style0 from "./edit-group.vue?vue&type=style&index=0&id=40236e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40236e2e",
  null
  
)

export default component.exports